import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {

    private showLoadingSubject = new Subject<boolean>();

    showLoading(show: boolean) {
        this.showLoadingSubject.next(show);
    }

    clearShowLoading() {
        this.showLoadingSubject.next();
    }

    getStatusLoading(): Observable<any> {
        return this.showLoadingSubject.asObservable();
    }
}